import { PatientAvatarBlockCard, SkeletonLoader } from '@equip.health/ui';
import { useGetPatientQuery } from '~/store/services/patients';

type Props = {
  patientId: string;
};
export const EditPatientNoteFormAvatarCard = ({ patientId }: Props) => {
  const { data: patient, isFetching: isGetPatientLoading } = useGetPatientQuery(
    { patientId },
    {
      skip: !patientId,
    },
  );

  if (isGetPatientLoading || !patient) {
    return <SkeletonLoader id={`patient-card-${patientId}`} />;
  }

  return (
    <PatientAvatarBlockCard
      addressState={patient.state}
      avatarUrl={patient.avatarSrc}
      chosenName={patient.chosenName}
      dobYyyyMmDdDashed={patient.dateOfBirth}
      firstName={patient.firstName}
      id={patientId}
      lastName={patient.lastName}
      pronouns={patient.pronounsOnRecord || []}
    />
  );
};
